<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>

<style >
  body {
    margin: 0;
    padding: 0;
    width:100%;
    height:100%;
    margin: 0;
    padding: 0;
    background-image: url('../static/img/2.png');
    background-repeat:no-repeat;
     background-attachment:fixed;
     background-size:100% 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue